var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('topheader',{directives:[{name:"show",rawName:"v-show",value:(
      !(_vm.path == '/forget' || _vm.path == '/login' || _vm.path == '/examination')
    ),expression:"\n      !(path == '/forget' || path == '/login' || path == '/examination')\n    "}],key:_vm.timer}),_c('router-view'),_c('r-footer',{directives:[{name:"show",rawName:"v-show",value:(
      !(
        _vm.path == '/forget' ||
        _vm.path == '/myTask' ||
        _vm.path == '/login' ||
        _vm.path == '/examination' ||
        _vm.path == '/taskOrder' ||
        _vm.path == '/taskHall' ||
        _vm.path == '/recruitList'
      )
    ),expression:"\n      !(\n        path == '/forget' ||\n        path == '/myTask' ||\n        path == '/login' ||\n        path == '/examination' ||\n        path == '/taskOrder' ||\n        path == '/taskHall' ||\n        path == '/recruitList'\n      )\n    "}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }